import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { dashboardQueryOptions } from './dashboard-query-options';

export enum Color {
  Green = 'green',
  Orange = 'orange',
  Red = 'red',
  Yellow = 'yellow',
}

export enum Label {
  Days0To30 = '0-30d',
  Days31To60 = '31-60d',
  Days61To90 = '61-90d',
  Days90Plus = '90+d',
}

export interface AccountsReceivableDueDateGrouping {
  label: Label;
  percentage: number;
  color: Color;
}

export interface GetAccountsReceivableDueDateGroupingParams {
  sessionId: string;
  range?: Label;
}

export const getAccountsReceivableDueDateGroupingAPI = async (
  params: GetAccountsReceivableDueDateGroupingParams,
) => {
  const response = await baseAPI.get<Array<AccountsReceivableDueDateGrouping>>(
    '/dashboard/metrics/account-receivable/duedate-grouping',
    {
      params,
    },
  );
  return response.data;
};

export const useGetAccountsReceivableDueDateGrouping = (
  params: GetAccountsReceivableDueDateGroupingParams,
) => {
  return useQuery({
    ...dashboardQueryOptions,
    queryKey: [
      KEYS.ACCOUNTS_RECEIVABLE_DUE_DATE_GROUPING,
      params.sessionId,
      params.range,
    ],
    queryFn: () => getAccountsReceivableDueDateGroupingAPI(params),
    enabled: !!params.sessionId,
  });
};
